var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, artworks, contain, disableEnd, disableStart, index, length, undefined) {
buf.push("<div class=\"hero-artworks-carousel\"><div class=\"mgr-cells js-mgr-cells\">");
// iterate artworks.models
;(function(){
  var $$obj = artworks.models;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

var dimensions = artwork.defaultImage().resizeDimensionsFor({ height: 300 })
buf.push("<div" + (jade.attr("style", "width:" + (dimensions.width) + "px;", true, true)) + " class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", artwork.href(), true, true)) + "><img" + (jade.attr("src", artwork.defaultImage().imageUrlForHeight(300), true, true)) + (jade.attr("alt", artwork.get('title'), true, true)) + (jade.attr("width", dimensions.width, true, true)) + (jade.attr("height", dimensions.height, true, true)) + "></a><div class=\"artist-name\">" + (jade.escape(null == (jade_interp = artwork.artistName()) ? "" : jade_interp)) + "</div><div class=\"title\">" + (null == (jade_interp = artwork.titleAndYear()) ? "" : jade_interp) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

var dimensions = artwork.defaultImage().resizeDimensionsFor({ height: 300 })
buf.push("<div" + (jade.attr("style", "width:" + (dimensions.width) + "px;", true, true)) + " class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", artwork.href(), true, true)) + "><img" + (jade.attr("src", artwork.defaultImage().imageUrlForHeight(300), true, true)) + (jade.attr("alt", artwork.get('title'), true, true)) + (jade.attr("width", dimensions.width, true, true)) + (jade.attr("height", dimensions.height, true, true)) + "></a><div class=\"artist-name\">" + (jade.escape(null == (jade_interp = artwork.artistName()) ? "" : jade_interp)) + "</div><div class=\"title\">" + (null == (jade_interp = artwork.titleAndYear()) ? "" : jade_interp) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div>");
length = artworks.length
buf.push("<nav class=\"mgr-navigation js-mgr-navigation\">");
index = index || 0
buf.push("<a" + (jade.attr("disabled", disableStart, true, true)) + " class=\"mgr-arrow-left icon-chevron-left js-mgr-prev\"></a><div class=\"mgr-dots\">");
if (!( contain))
{
// iterate new Array(length)
;(function(){
  var $$obj = new Array(length);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-mgr-select',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-mgr-select',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  }
}).call(this);

}
buf.push("</div><a" + (jade.attr("disabled", disableEnd, true, true)) + " class=\"mgr-arrow-right icon-chevron-right js-mgr-next\"></a></nav></div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"artworks" in locals_for_with?locals_for_with.artworks:typeof artworks!=="undefined"?artworks:undefined,"contain" in locals_for_with?locals_for_with.contain:typeof contain!=="undefined"?contain:undefined,"disableEnd" in locals_for_with?locals_for_with.disableEnd:typeof disableEnd!=="undefined"?disableEnd:undefined,"disableStart" in locals_for_with?locals_for_with.disableStart:typeof disableStart!=="undefined"?disableStart:undefined,"index" in locals_for_with?locals_for_with.index:typeof index!=="undefined"?index:undefined,"length" in locals_for_with?locals_for_with.length:typeof length!=="undefined"?length:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;